import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { Box, Divider, MenuItem, Theme, Typography } from '@mui/material';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import makeStyles from '@mui/styles/makeStyles';
import { useI18n } from '../../../../lib/hook/useI18n';

type Props = {
  onDeleteChatHistory: () => void;
  isExpanded: boolean;
  onExpandToggle: () => void;
};

const useStyles = makeStyles((theme: Theme) => ({
  menuItem: {
    padding: theme.spacing(0.5, 3),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  menuItemIcon: {
    height: theme.spacing(2),
    width: theme.spacing(2.5),
  },
}));

const ActionsMenuItems: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useI18n();
  const classes = useStyles();
  const { onDeleteChatHistory, isExpanded, onExpandToggle } = props;

  return (
    <>
      <MenuItem
        dense
        onClick={onExpandToggle}
        data-testid="action-delete-room"
        className={classes.menuItem}
      >
        {isExpanded ? (
          <CloseFullscreenIcon className={classes.menuItemIcon} />
        ) : (
          <OpenInFullIcon className={classes.menuItemIcon} />
        )}
        <Typography variant="body2">
          {isExpanded
            ? t('buyerCopilot.actionsMenu.collapseWindow')
            : t('buyerCopilot.actionsMenu.expandWindow')}
        </Typography>
      </MenuItem>
      <Box py={1}>
        <Divider />
      </Box>
      <MenuItem
        dense
        onClick={onDeleteChatHistory}
        data-testid="action-delete-room"
        className={classes.menuItem}
      >
        <DeleteOutlined color="error" className={classes.menuItemIcon} />
        <Typography color="error" variant="body2">
          {t('buyerCopilot.actionsMenu.deleteChatHistory')}
        </Typography>
      </MenuItem>
    </>
  );
};

export default ActionsMenuItems;
